var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000170973946151134439280000016744767998188226988_);}\r\n\t.st2{fill:url(#SVGID_00000000902058273360238990000003031277478368341943_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.9308,
    y1: 113.7158,
    x2: 99.1609,
    y2: -5.7197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2DB33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#C7D839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2906,
    style: {
      stopColor: "#ABD048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5319,
    style: {
      stopColor: "#7CC461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#3DB384"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#10A79C"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 49.1,
    className: "st0",
    width: 22.1,
    height: 50.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127723522802923749890000013160729287747408022_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.0589,
    y1: 136.1119,
    x2: 106.7654,
    y2: 6.5902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2DB33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#C7D839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2906,
    style: {
      stopColor: "#ABD048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5319,
    style: {
      stopColor: "#7CC461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#3DB384"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#10A79C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 20.8,
    style: {
      fill: "url(#SVGID_00000127723522802923749890000013160729287747408022_)"
    },
    width: 22.1,
    height: 79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066482467037160574000000002247004142019927480_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2272,
    y1: 155.9015,
    x2: 105.8412,
    y2: 29.9095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2DB33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#C7D839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2906,
    style: {
      stopColor: "#ABD048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5319,
    style: {
      stopColor: "#7CC461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#3DB384"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#10A79C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: -1,
    style: {
      fill: "url(#SVGID_00000066482467037160574000000002247004142019927480_)"
    },
    width: 22,
    height: 100.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.b6f53690c31c99e3bed6432ceae31af6.svg";
export { ForwardRef as ReactComponent };